module.exports = (function(){
	return {
		//Navigation
		menu: false,

		//Scrolling
		css3: true,
		scrollingSpeed: MUR.animation.duration,
		autoScrolling: false,
		fitToSection: false,
		autoScrolling: true,
		fitToSection: true,
		scrollBar: false,
		easing: 'easeInOutCubic',
		easingcss3: 'ease',
		loopBottom: false,
		loopTop: false,
		loopHorizontal: false,
		continuousVertical: false,
		scrollOverflow: false,
		touchSensitivity: 15,
		normalScrollElementTouchThreshold: 5,

		//Accessibility
		keyboardScrolling: true,
		animateAnchor: true,
		recordHistory: true,

		sectionSelector: '[class^="section-"]',

		//Design
		controlArrows: true,
		verticalCentered: true,
		resize : false,
		responsive: 767
	}
})();
